import FormativeReportsPreviewContainer from './FormativeReportsPreviewContainer' // eslint-disable-line

export default FormativeReportsPreviewContainer
